import { ButtonGroup, Flex, InputGroup } from "@chakra-ui/react";

import { DealerOrganizationPropertiesFilterPopover } from "src/routes/DealerOrganization/DealerOrganizationPropertiesFilterPopover";

export const DealerOrganizationPropertiesFilterBar = () => {
  return (
    <Flex flexDirection="row">
      <InputGroup>
        <ButtonGroup gap="8px">
          <DealerOrganizationPropertiesFilterPopover />
        </ButtonGroup>
      </InputGroup>
    </Flex>
  );
};
